import { Component, OnInit } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ActionSheetController, IonicPage, Platform, ViewController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';

@IonicPage()
@Component({
  selector: 'page-select-image-add',
  templateUrl: 'select-image-add.html',
})
export class SelectImageAddPage {
  isNoData:boolean = true;
  show:boolean = false;
  isBase64:boolean = true;
  isUpdate:boolean = false;
  params:any = {};
  photo:any = "";
  comment:any = "";
  constructor(
    public viewCtrl: ViewController,
    private api: CrudProvider,
    private utiltiy: UtiltiyProvider,
    public platform: Platform,
    public camera:Camera,
    public actionSheetController: ActionSheetController,
  ) {
    if(this.viewCtrl.data.isKlmr){
      this.show = true;
    }
    if(this.viewCtrl.data.data){
      this.isUpdate = true;
      this.params = this.viewCtrl.data.data;
      console.log("this.params",this.params)
      this.comment = this.params.comment.comment;
      this.photo = this.params.comment.images;
      if(this.params.comment.images.length > 0 ){
        this.isBase64 = true;

      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectImageAddPage',this.viewCtrl.data);
  }

  closeModal(){
    this.viewCtrl.dismiss()
  }

  clearImage(){
    this.photo = "";
    this.isBase64 = true;
  }

  async onPhotoGraphy(event, type, index) {
    if (type == 1) {
      this.mobileUploads(index)
    } else if (type == 2) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.utiltiy.getBase64(event.target.files[i]).then(
          async (data: any) => {
            console.log("data", data)
            // this.selectedFleetItems[index].photo = data;
            this.isBase64 = false;
             this.base64tofile(data,"this.selectedFleetItems[index].name");
          }).catch(error => {
            console.log('error', error);
          });
      }
    }
  }

  async base64tofile(base64, fileName) {
    const res: Response = await fetch(base64);
    const blob: Blob = await res.blob();
    const file = new File([blob], fileName.replace(/ /g, '') + `.png`, { type: 'image/png' });
    this.photo = file
    console.log(file);
  }

  async mobileUploads(index) {
    const actionSheet = await this.actionSheetController.create({
      title: 'Select Image source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.pickImage(this.camera.PictureSourceType.PHOTOLIBRARY);
          },
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.pickImage(this.camera.PictureSourceType.CAMERA);
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
        },
      ],
    });
    await actionSheet.present();
    // this.onInput('', 'Photography');
  }

  pickImage(sourceType) {
    let image: any;

    const options: CameraOptions = {
      quality: 20,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
    };
    this.camera.getPicture(options).then(
      (imageData) => {
        image = 'data:image/jpeg;base64,' + imageData;
        this.isBase64 = false;

    this.base64tofile(image,"this.selectedFleetItems[index].name");

      // this.loadingService.dismissLoading();
      },

      (err) => {
        // this.loadingService.dismissLoading();
        console.log("errOf Image ", err)
      }
    );
  }



  async submit(){

    if(this.comment.length == 0 || this.photo.length == 0){
      this.utiltiy.toaster("Comment and image required");
      return;
    }
   
    let formData: FormData = new FormData();
    if(this.isUpdate){
      formData.append("method_name", "update_images");
      formData.append("plantitem_id", this.viewCtrl.data.id);
      formData.append("gallery_comment_id", this.viewCtrl.data.data.comment.id);
      formData.append("gallery_comment_group", this.viewCtrl.data.data.comment.group);
      formData.append("gallery_comment", this.comment);
      if(!this.isBase64){
        formData.append("image[]", this.photo);
      }
    }else{
      formData.append("method_name", "store_image");
      formData.append("plantitem_id", this.viewCtrl.data.id);
      formData.append("comment", this.comment);
      formData.append("image[]", this.photo);
    }
    this.apiCall(formData);
  }

  apiCall(formData){
    let baseUrl = this.show ?"/prestart/Fleet_Information/Fleet_Information":"/tansix_prestart/Fleet_Information/Fleet_Information";
    return this.api.post(baseUrl, false, formData)
      .then((result: any) => {
        this.utiltiy.stopLoading();
        console.log("result", result)
        if (result.status) {
          this.utiltiy.toaster(result.message);
            this.viewCtrl.dismiss(true)

        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
    
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-image-add/select-image-add.ts